export class InsertDailyBalanceViewModel {
  date: moment.Moment;
  egmId: number;
}
